import Question, { SelectionWrapper } from './question';
import SingleSelection from './radio';
import MultipleSelection from './checkbox';
import BlankFilling from './blankFilling';
import ScaleBar from './scaleBar';
import MultiRadio from './multiRadio';
import WithAdditionalInput from './withAdditionalInput';

import Execution from '../execution';
import { QUES_COMPONENT_TYPES } from '@model/questionmaires';

// import '@style/modules/questionnaires/question.scss';
import '../../../styles/modules/questionnaires/question.scss';

const QUES_COMPONENTS = {
  [QUES_COMPONENT_TYPES.INPUT]: BlankFilling,
  [QUES_COMPONENT_TYPES.CHECKBOX]: MultipleSelection,
  [QUES_COMPONENT_TYPES.RADIO]: SingleSelection,
  [QUES_COMPONENT_TYPES.SCALE]: ScaleBar,
  [QUES_COMPONENT_TYPES.MULTIRADIO]: MultiRadio,
  [QUES_COMPONENT_TYPES.EXECUTION]: Execution,
  [QUES_COMPONENT_TYPES.SCALEWITHINPUT]: WithAdditionalInput(ScaleBar),
  [QUES_COMPONENT_TYPES.RADIOWITHINPUT]: WithAdditionalInput(SingleSelection),
};

export default Question;
export {
  SingleSelection,
  ScaleBar,
  MultipleSelection,
  SelectionWrapper,
  BlankFilling,
  Execution,
  QUES_COMPONENTS,
  MultiRadio,
};
